/* unplugin-vue-components disabled */import { render } from "./onboarding-research.vue?vue&type=template&id=0b6bf99c&scoped=true"
import script from "./onboarding-research.vue?vue&type=script&lang=js"
export * from "./onboarding-research.vue?vue&type=script&lang=js"

import "./onboarding-research.vue?vue&type=style&index=0&id=0b6bf99c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6bf99c"],['__file',"src/components/ai-chat-v2/ai-assistant/research/onboarding-research.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b6bf99c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b6bf99c', __exports__)) {
    api.reload('0b6bf99c', __exports__)
  }
  
  module.hot.accept("./onboarding-research.vue?vue&type=template&id=0b6bf99c&scoped=true", () => {
    api.rerender('0b6bf99c', render)
  })

}


export default __exports__